module.exports = __webpack_public_path__ + "static/media/np.9341c237.svg";